import * as Yup from 'yup'
import {
  mandatoryEmailMessasge,
  migrationProductRequiredMessage,
  requiredFieldMessage,
  websiteValidationCheckMessage,
} from './messagesConstants'
import {
  buyerFormFieldsSchema,
  hexOrRgbColorValidation,
} from './FlyoutProductValidationSchema'
import { urlPatternWithHttps } from './constants'

export const migrationDetailsSchema = Yup.object({
  products: Yup.array().min(1, migrationProductRequiredMessage),
})

const emailArrayValidation = Yup.string()
  .email('Enter valid emails')
  .required(mandatoryEmailMessasge)

export const notificationRecipientsSchema = Yup.object({
  registrationCompleted: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  privateOfferRenewalReminder: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  registrationIncompleteOffer: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  subscribeFail: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  entitlementRenew: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  entitlementExpired: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  entitlementUpgrade: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  unsubscribePending: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  unsubscribeSuccess: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  privateOfferExpired: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  privateOfferAccepted: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  privateOfferCreated: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  privateOfferExpiringSoon: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  privateOfferRestrictionSuccess: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  meteringSent: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  resellerAgreementCreated: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  resellerAgreementDeactivated: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  resellerAgreementExpiringSeller: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
  resellerAgreementExpiredSeller: Yup.array()
    .of(emailArrayValidation)
    .min(1, mandatoryEmailMessasge)
    .required(mandatoryEmailMessasge),
})

export const termsAndConditionsHelperSchema = Yup.object().shape({
  infoCollectionFormMetaData: Yup.array()
    .of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.bool().oneOf(
          [true],
          'You must check all boxes before continuing.'
        ),
        type: Yup.string().oneOf(['checkbox']).required(),
      })
    )
    .required(),
  notificationRecipients: Yup.array()
    .of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.bool().oneOf(
          [true],
          'You must check all boxes before continuing.'
        ),
        type: Yup.string().oneOf(['checkbox']).required(),
      })
    )
    .required(),
})

const generalInformationSchema = Yup.object().shape({
  termsAndCondition: Yup.boolean().oneOf(
    [true],
    'You must check this box before continuing.'
  ),
})

export const infoCollectionFormMetaDataSchema = Yup.object({
  redirectUrl: Yup.string().matches(
    urlPatternWithHttps,
    websiteValidationCheckMessage
  ),
  redirectSeconds: Yup.number()
    .typeError('Redirect seconds must be a valid number')
    .min(0, 'Not negative number'),
  submissionSuccessMessage: Yup.string()
    .trim(requiredFieldMessage)
    .required(requiredFieldMessage)
    .max(2000, 'Max 2000 characters are allowed'),
  headingMessage: Yup.string()
    .trim(requiredFieldMessage)
    .required(requiredFieldMessage)
    .max(2000, 'Max 2000 characters are allowed'),
  privacyPolicyLink: Yup.string().matches(
    urlPatternWithHttps,
    websiteValidationCheckMessage
  ),
  emailCustomMessage: Yup.string()
    .trim(requiredFieldMessage)
    .max(2000, 'Max 2000 characters are allowed'),
  existingBuyerMessage: Yup.string()
    .trim(requiredFieldMessage)
    .required(requiredFieldMessage)
    .max(2000, 'Max 2000 characters are allowed'),
  existingBuyerRedirectSeconds: Yup.number()
    .typeError('Redirect seconds must be a valid number')
    .min(0, 'Not negative number'),
  buyerFormFields: buyerFormFieldsSchema,
  redirectionSettings: Yup.object({
    applicationLoginPageUrl: Yup.string()
      .trim(requiredFieldMessage)
      .required(requiredFieldMessage)
      .url(websiteValidationCheckMessage),
  }),
  bgColor: hexOrRgbColorValidation,
  buttonColor: hexOrRgbColorValidation,
  buttonTextColor: hexOrRgbColorValidation,
})

const FlyoutProductValidationSchemaMicrosoft = Yup.object().shape({
  generalInformation: generalInformationSchema,
  migrationDetails: migrationDetailsSchema,
  infoCollectionFormMetaData: infoCollectionFormMetaDataSchema,
  notificationRecipients: notificationRecipientsSchema,
  buyerFormFields: buyerFormFieldsSchema,
  termsAndConditions: termsAndConditionsHelperSchema,
})

export default FlyoutProductValidationSchemaMicrosoft
